"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPagination = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function SearchPagination(_a) {
    var handlePageClick = _a.handlePageClick, pageCount = _a.pageCount, page = _a.page, maxPages = _a.maxPages;
    if (pageCount < 2) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(core_ui_1.Stack, { direction: "vertical", gap: 8 },
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-end" },
            react_1.default.createElement(core_ui_1.Padding, { top: 24 },
                react_1.default.createElement(core_ui_1.PaginationControls, { forcePage: page, pageCount: pageCount, onPageChange: handlePageClick }))),
        maxPages && (react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-end" },
            react_1.default.createElement(core_ui_1.Text, { size: "small", weight: 300 },
                "A maximum of ",
                maxPages,
                " pages are shown, please narrow your search query if you cannot find the result in the first ",
                maxPages,
                " pages.")))));
}
exports.SearchPagination = SearchPagination;
